import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import ArticleCard from '@/common/interfaces/modules/ArticleCard';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';

const NextPrevArticleProps = Vue.extend({
  props: { prev: Object as () => ArticleCard, next: Object as () => ArticleCard },
});

@Component({
  components: {
    ResponsiveImage,
  },
})
export default class NextPrevArticle extends NextPrevArticleProps {
  imageSizes: ImageSizes = {
    def: new ImageSize([106, 85]),
    sizes: {
      sm: new ImageSize([106, 85]),
    },
  };
}
